import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Question } from '../question-model';
import store from '@/trust-atcs-app/store';
import Popover from '@/shared/components/popover/index.vue';
import { orderBy } from 'lodash';

@Options<RadioButtonVertical>({
  components: {
    Popover
  }
})
export default class RadioButtonVertical extends Vue {

  @Prop()
  private question!: any;

  @Watch('selectedOption')
  private onSelectedOptionChanged(): void {
    this.question.responses.forEach((r: any, i: number) => {
      if (r.value == this.selectedOption) {
        this.question.responses[i].answerIsSelected = true;
      } else {
        this.question.responses[i].answerIsSelected = null;
      }
    });
    this.$emit('validForm', this.validForm());
  }

  private uniqueIdName = null as any;
  private selectedOption = null as any;
  private newWording = '';
  private obj = null as any;

  created(): void {
    this.uniqueIdName = 'RadioVertical' + this.question.id;
    this.question.responses = orderBy(this.question.responses, 'order', 'asc'); 
    this.initField();
    const content = store.getters.getPopovers;
    if (this.question.wording.match(/--{{([^)]+)}}--/)) {
      const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
      this.obj = content.filter((x: any) => x.key == popovers)[0];
      this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
    } else {
      this.newWording = this.question.wording;
    }
    this.$emit('validForm', this.validForm());
  }

  private initField(): void {
    const defaultSelection = this.question.responses.filter((x: any) => x.answerIsSelected);
    if (defaultSelection.length > 0) {
      this.selectedOption = defaultSelection[0].value;
    }
  }

  private getLinedQuestionResponse(responses: any[]): string {
    return responses.map((r: any) => r.answerIsSelected ? r.wording : '').join(' ');
  }

  private validForm(): boolean {
    return this.selectedOption != null;
  }

}
